import { render, staticRenderFns } from "./Counterpart.vue?vue&type=template&id=44355d44&"
import script from "./Counterpart.vue?vue&type=script&lang=ts&"
export * from "./Counterpart.vue?vue&type=script&lang=ts&"
import style0 from "./Counterpart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports